export { SmartPaginationDots } from './SmartPaginationDots';
export type { SmartPaginationDotsProps } from './SmartPaginationDots';

export { PaginationDots } from './PaginationDots';

export { PaginationDot } from './PaginationDot';
export type { PaginationDotProps } from './PaginationDot';
